/**
 * Country Popup Component
 * Manages the country recommendation popup behavior
 * Synced with redirect.liquid for geolocation-based recommendations
 */

export default function countryPopup() {
  return {
    init() {},

    handleTemporaryClose() {
      // Just close the popup, don't save anything
      this.$store.countryPopup.set(false, "", "");
    },

    /**
     * Handle dismiss action
     * Stores dismissal in localStorage to persist across sessions
     * Only clears if physical location (IP) changes
     */
    handleDismiss() {
      const countryCode = this.$store.countryPopup.countryCode;

      try {
        // Store dismissal in localStorage (persists across sessions)
        localStorage.setItem("countryRecommendationDismissed", countryCode);
      } catch (e) {
        console.error("Failed to store dismissal:", e);
      }

      // Close popup
      this.$store.countryPopup.set(false, "", "");
    },

    /**
     * Handle confirm action
     * Redirects to the recommended market/domain
     * For external redirects: referrer check in redirect.liquid prevents popup on new domain
     */
    handleConfirm() {
      const link = this.$store.countryPopup.link;
      const countryCode = this.$store.countryPopup.countryCode;

      try {
        // Store choice in localStorage (persists across sessions)
        localStorage.setItem(
          "localizationChoice",
          `manual-selection-${countryCode}`
        );
      } catch (e) {
        console.error("Failed to store choice:", e);
      }

      // Close popup
      this.$store.countryPopup.set(false, "", "");

      // Redirect to target URL
      if (link) {
        // External domain redirect (e.g., EU → US or US → EU)
        window.location.href = link;
      } else {
        // Internal market redirect via Shopify form
        const form = this.$refs.countryForm;
        if (form) {
          form.submit();
        }
      }
    },
  };
}
